<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        Clientes
      </div>
      <v-data-table
        :headers="headers"
        :items="dados"
        :server-items-length="total"
        :options.sync="options"
        loading-text="Carregando... Por favor aguarde"
        :loading="carregando"
        class="elevation-1 base_table"
        disable-sort
        :footer-props="{
          itemsPerPageOptions: [5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
      >
        <template v-slot:top>
          <v-row no-gutters align="center" justify="space-between">
            <div class="py-2 px-2">
              <v-row no-gutters>
                <v-form @submit.prevent="buscaItens()">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="search"
                    outlined
                    label="Busca"
                    @click:clear="limparBusca()"
                  ></v-text-field>
                </v-form>
                <v-autocomplete
                  class="ml-3"
                  v-if="nivelUsuarioApelido === 'M'"
                  :menu-props="{ offsetY: true}"
                  :items="distribuidores"
                  label="Distribuidor"
                  append-icon="expand_more"
                  v-model="distribuidor"
                  hide-details=""
                  :loading="loading || loadingDistribuidores"
                  :disabled="loading || loadingDistribuidores"
                  outlined
                  @click:clear="() => {
                    this.options.page = 1
                    this.applyFilter()
                  }"
                  clearable
                  clear-icon="close"
                  @change="applyFilter()"
                ></v-autocomplete>
                <v-autocomplete
                  v-if="nivelUsuarioApelido === 'M' || nivelUsuarioApelido === 'D'"
                  :menu-props="{ offsetY: true}"
                  class="ml-3"
                  :items="integradores"
                  label="Integrador"
                  append-icon="expand_more"
                  v-model="integrador"
                  hide-details=""
                  :loading="loading || loadingIntegradores"
                  :disabled="loading || loadingIntegradores"
                  outlined
                  @click:clear="() => {
                    this.options.page = 1
                    this.applyFilter()
                  }"
                  clearable
                  clear-icon="close"
                  @change="applyFilter()"
                ></v-autocomplete>
                <v-autocomplete
                  class="ml-3"
                  :menu-props="{ offsetY: true}"
                  :items="estados"
                  label="Estado"
                  append-icon="expand_more"
                  v-model="estado"
                  hide-details=""
                  :loading="loading || loadingEstados"
                  :disabled="loading || loadingEstados"
                  outlined
                  @click:clear="() => {
                    this.options.page = 1
                    this.applyFilter()
                  }"
                  clearable
                  clear-icon="close"
                  @change="filterCidade()"
                ></v-autocomplete>
                <v-autocomplete
                  class="ml-3"
                  :menu-props="{ offsetY: true}"
                  :items="cidadesFiltro"
                  label="Cidade"
                  append-icon="expand_more"
                  v-model="cidade"
                  hide-details=""
                  :loading="loading || loadingCidades"
                  :disabled="loading || loadingCidades"
                  outlined
                  @click:clear="() => {
                    this.options.page = 1
                    this.applyFilter()
                  }"
                  clearable
                  clear-icon="close"
                  @change="applyFilter()"
                ></v-autocomplete>
              </v-row>
            </div>
            <div>
              <v-menu
                bottom
                center
                offset-y
                max-height="400"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    Exportar
                    <v-icon>arrow_drop_down</v-icon>
                  </div>
                </template>
                <v-list>
                  <v-list-item @click="exportXls()">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">receipt_long</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para XLS</v-list-item-title>
                  </v-list-item>
                  <!-- <v-list-item @click="exportPdf()">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">assignment</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para PDF</v-list-item-title>
                  </v-list-item> -->
                </v-list>
              </v-menu>
            </div>
          </v-row>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row no-gutters align="center" justify="center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openDialog(item)" color="primary" class="mr-2" :disabled="salvando">
                  edit
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openDialogDelete(item)" color="primary" class="ml-2">
                  delete
                </v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
    </div>
    <div class="ui-create">
      <v-btn color="primary" elevation="3" @click="dialogCliente = true" :loading="loading" :disabled="loading">
        <v-icon color="white" x-large>add</v-icon>
      </v-btn>
    </div>
    <v-dialog
      v-model="dialogCliente"
      persistent
      max-width="900px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{cliente.uuid_cli_id ? 'Editar' : 'Novo'}}  cliente
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formCliente">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
              <v-text-field
                v-model="cliente.cli_nome"
                label="Nome completo*"
                autofocus
                :rules="[rules.required, rules.min]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <!-- <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                v-model="cliente.cli_usuario"
                label="Login*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                v-model="cliente.cli_senha"
                outlined
                hint="Mínimo 6 caracteres"
                counter
                :rules="[rules.required, rules.min6]"
                label="Senha*"
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col> -->
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                v-model="cliente.cli_email"
                label="E-mail"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                v-model="cliente.cli_telefone"
                label="Telefone"
                :loading="salvando"
                :disabled="salvando"
                outlined
                v-mask="'(##) #####-####'"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                v-model="cliente.cli_celular"
                label="Celular*"
                :rules="[rules.required]"
                :loading="salvando"
                :disabled="salvando"
                outlined
                v-mask="'(##) #####-####'"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
            <v-text-field-cep
              v-model="cliente.cli_cep"
              label="CEP"
              :loading="loadingCep || salvando"
              :disabled="loadingCep || salvando"
              @change="searchCep(cliente.cli_cep)"
              v-bind:properties="{
                disabled: false,
                outlined: true,
                clearable: true,
                placeholder: '',
              }"
              v-bind:options="{
                outputMask: '########',
                empty: null,
                applyAfter: false,
              }"
            />
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-autocomplete
                v-model="cliente.cli_uf"
                autocomplete="off"
                :items="estados"
                :loading="salvando || loadingEstados || loadingCep"
                :disabled="salvando || loadingEstados || loadingCep"
                label="Estado"
                append-icon="expand_more"
                outlined
                @change="filterCidade(cliente.cli_uf)"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-autocomplete
                autocomplete="off"
                v-model="cliente.cli_cidade"
                :items="cidadesFiltradas"
                :loading="salvando || loadingCidades || loadingCep"
                :disabled="salvando || loadingCidades || loadingCep"
                label="Cidade"
                append-icon="expand_more"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                v-model="cliente.cli_bairro"
                outlined
                :loading="salvando || loadingCep"
                :disabled="salvando || loadingCep"
                label="Bairro"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" lg="3" xl="3" class="pt-0">
              <v-text-field
                v-model="cliente.cli_rua"
                outlined
                :loading="salvando || loadingCep"
                :disabled="salvando || loadingCep"
                label="Rua"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="pt-0">
              <v-text-field
                v-model="cliente.cli_numero"
                outlined
                :loading="salvando || loadingCep"
                :disabled="salvando || loadingCep"
                label="Número"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pt-0">
              <v-text-field
                v-model="cliente.cli_complemento"
                outlined
                :loading="salvando || loadingCep"
                :disabled="salvando || loadingCep"
                label="Complemento"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" lg="3" xl="3" class="pt-0" v-if="nivelUsuarioApelido === 'M' || nivelUsuarioApelido === 'D'">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="cliente.uuid_int_id"
                :items="integradoresCadastro"
                clearable
                clear-icon="close"
                label="Integrador*"
                :rules="[rules.required]"
                append-icon="expand_more"
                :loading="salvando || loadingIntegradores"
                :disabled="salvando || loadingIntegradores"
                outlined
              ></v-autocomplete>
            </v-col>
          </v-row>
         </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditCliente()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Cliente
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelDialogDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Cliente <b class="text-primary">{{cliente ? cliente.cli_nome : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="cancelDialogDelete()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :disabled="salvando"
            :loading="salvando"
            @click="removeCliente()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@API'
import axios from 'axios'
import RelatorioBase from '@components/impressoes/RelatorioBase.vue'

export default {
  data () {
    return {
      nivelUsuarioApelido: '',
      loading: true,
      salvando: false,
      dialogCliente: false,
      showPassword: false,
      showRepeatPassword: false,
      loadingCep: false,
      estados: [],
      cidades: [],
      cidadesFiltro: [],
      cidade: null,
      estado: null,
      cidadesFiltradas: [],
      loadingEstados: false,
      loadingCidades: false,
      integradores: [],
      integradoresCadastro: [],
      integrador: null,
      distribuidor: null,
      distribuidores: [],
      search: '',
      searchFinal: '',
      distribuidorAnterior: null,
      total: 0,
      options: {},
      carregando: false,
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'cli_id'
        },
        { text: 'Nome', value: 'cli_nome' },
        { text: 'Estado', value: 'cli_uf' },
        { text: 'Cidade', value: 'cli_cidade' },
        { text: 'Bairro', value: 'cli_bairro' },
        { text: 'Integrador', value: 'integrador.int_nome' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dados: [],
      rules: {
        min6: value => !!value[5] || 'minimo 6 caracteres.',
        min: v => !!(v.split(' ').length > 1 & v.split(' ')[1] !== '') || 'Obrigatório nome e sobrenome',
        required: value => !!value || 'Obrigatório.'
      },
      confirmPasswordRules: [
        (value) => !!value || 'Confirme a senha',
        (value) =>
          value === this.cliente.cli_senha || 'A confirmação da senha não corresponde.'
      ],
      loadingIntegradores: false,
      dialogExcluir: false,
      cliente: {
        cli_nome: '',
        cli_cep: '',
        cli_uf: '',
        cli_cidade: '',
        cli_bairro: '',
        cli_rua: '',
        cli_numero: '',
        cli_complemento: '',
        cli_telefone: '',
        cli_celular: '',
        cli_email: '',
        cli_usuario: null,
        cli_senha: null
      }
    }
  },
  watch: {
    options: {
      handler () {
        this.getClientes()
      },
      deep: true
    }
  },
  methods: {
    async exportXls () {
      this.loadingXls = true
      Api.post('relatorios', {
        headers: this.someHeader(),
        distribuidor: this.distribuidor,
        integrador: this.integrador,
        busca: this.searchFinal,
        cidade: this.cidade,
        estado: this.estado,
        type: 'clientes'
      })
        .then(res => {
          const baseUrl = window.location.origin
          this.downloadXls(baseUrl + '/' + res.data.url)
          this.removeXls(res.data.url)
          this.loadingXls = false
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao fazer o donwload!',
            color: 'error'
          })
        })
    },
    async downloadXls (url) {
      const a = document.createElement('a')
      a.href = url
      a.download = url.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    removeXls (url) {
      let data = {
        url: url
      }
      Api.post('relatorios/remove-s3', data)
    },
    exportPdf () {
      this.$root.Printer.openDialog(this, {
        titulo: 'Clientes', // Título que aparece centralizado na página e como nome do dialog
        component: RelatorioBase, // componente com o layout a ser impresso
        data: this.dados,
        headers: this.someHeader(), // dados para alimentar o componente, por padrão ele chegará como o props data no componente
        css: `` // Classes css que são adicionados na página de impressão
      })
    },
    someHeader () {
      let cabecalhos = []
      this.headers.map(header => {
        if (header.text !== 'ID' && header.text !== 'Ações' && header.text !== 'Usuários') cabecalhos.push(header)
      })
      return cabecalhos
    },
    loadFunctions () {
      let filters = this.$route.query
      if (filters.distribuidor) this.distribuidor = filters.distribuidor
      if (filters.integrador) this.integrador = filters.integrador
      if (filters.estado) this.estado = filters.estado
      if (filters.cidade) this.cidade = filters.cidade
      if (filters.busca) {
        this.search = filters.busca
        this.searchFinal = filters.busca
      }

      this.getEstados()
      this.getCidade()
      this.getDistribuidores()
      if (this.nivelUsuarioApelido !== 'I') {
        this.getIntegradores()
      }
      this.getClientes()
    },
    async getDistribuidores () {
      this.loadingDistribuidores = true
      await Api.get('distribuidores')
        .then(res => {
          var arrayDists = []
          res.data.map(dist => {
            arrayDists.push({
              'text': dist.dis_nome,
              'value': dist.uuid_dis_id
            })
          })
          this.distribuidores = arrayDists
          this.loadingDistribuidores = false
        })
        .catch(err => {
          this.loadingDistribuidores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os distribuidores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    buscaItens () {
      this.searchFinal = this.search
      this.options.page = 1
      this.applyFilter()
    },
    limparBusca () {
      this.search = null
      this.searchFinal = null
      this.options.page = 1
      this.applyFilter()
    },
    applyFilter () {
      if (this.distribuidorAnterior && this.distribuidor !== this.distribuidorAnterior) {
        this.integrador = ''
      }

      let query = Object.assign({},
        this.distribuidor ? { distribuidor: this.distribuidor } : '',
        this.integrador ? { integrador: this.integrador } : '',
        this.searchFinal ? { busca: this.searchFinal } : '',
        this.estado ? { estado: this.estado } : '',
        this.cidade ? { cidade: this.cidade } : ''
      )

      this.$router.replace({name: 'Cliente', query: query}).catch(() => {})
      this.dados = []
      this.distribuidorAnterior = this.distribuidor
      this.getIntegradores(this.distribuidor)
      this.getClientes()
    },
    async getIntegradores (distribuidor = null, cadastro = false) {
      this.loadingIntegradores = true
      let url = 'integradores'

      if (distribuidor) {
        url = `integradores/distribuidor/${distribuidor}`
      }
      await Api.get(url)
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            arrayInt.push({
              'text': int.int_nome,
              'value': int.uuid_int_id
            })
          })
          if (cadastro || (!cadastro && !distribuidor)) {
            this.integradoresCadastro = arrayInt
          }

          if (!cadastro) {
            this.integradores = arrayInt
          }
          this.loadingIntegradores = false
        })
        .catch(err => {
          this.loadingIntegradores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getClientes () {
      this.carregando = true
      this.total = 0
      this.dados = []
      let filtro = '&filtro='

      const { page, itemsPerPage } = this.options
      let pagina = 1
      let itensPagina = 10
      if (page) {
        pagina = page
      }
      if (itemsPerPage) {
        itensPagina = itemsPerPage
      }

      if (this.distribuidor) {
        filtro += '&distribuidor=' + this.distribuidor
      }
      if (this.integrador) {
        filtro += '&integrador=' + this.integrador
      }
      if (this.searchFinal) {
        filtro += '&busca=' + this.searchFinal
      }
      if (this.estado) {
        filtro += '&estado=' + this.estado
      }
      if (this.cidade) {
        filtro += '&cidade=' + this.cidade
      }
      await Api.get(`clientes?page=${pagina}&per_page=${itensPagina}${filtro}`)
        .then(res => {
          this.total = res.data.total
          this.dados = res.data.data
          this.carregando = false
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.carregando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os clientes!',
            color: 'error'
          })
          console.log(err)
        })
    },
    openDialog (item) {
      this.dialogCliente = true
      this.salvando = true
      Api.get('clientes/' + item.uuid_cli_id)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          if (response.data.cli_uf) {
            this.filterCidade(response.data.cli_uf)
          }
          this.cliente = JSON.parse(JSON.stringify(response.data))
          this.cliente.uuid_int_id = response.data.integrador.uuid_int_id
        })
        .catch((error) => {
          this.salvando = false
          this.dialogCliente = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados do cliente!',
            color: 'error'
          })
        })
    },
    saveEditCliente () {
      if (!this.$refs.formCliente.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'clientes/novo'
      let editado = false
      if (this.cliente.uuid_cli_id) {
        endpoint = 'clientes/edita'
        editado = true
      }

      if (this.user.fk_int_id_integrador) {
        this.cliente.uuid_int_id = this.user.uuid_int_id
      }
      Api.post(endpoint, this.cliente)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Cliente atualizado com sucesso!' : 'Cliente cadastrado com sucesso!',
            color: 'success'
          })
          this.closeDialog()
          this.getClientes()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    openDialogDelete (item) {
      this.cliente = JSON.parse(JSON.stringify(item))
      this.dialogExcluir = true
    },
    cancelDialogDelete () {
      this.closeDialog()
      this.dialogExcluir = false
    },
    removeCliente () {
      this.salvando = true
      Api.delete(`clientes/remove/${this.cliente.uuid_cli_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.message
          })
          this.dialogExcluir = false
          this.salvando = false
          this.closeDialog()
          this.getClientes()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover cliente!',
            color: 'error'
          })
        })
    },
    closeDialog () {
      this.cliente = {
        cli_nome: '',
        cli_cep: '',
        cli_uf: '',
        cli_cidade: '',
        cli_bairro: '',
        cli_rua: '',
        cli_numero: '',
        cli_complemento: '',
        cli_telefone: '',
        cli_celular: '',
        cli_email: '',
        cli_usuario: null,
        cli_senha: null
      }
      if (this.$refs.formCliente) {
        this.$refs.formCliente.resetValidation()
      }
      this.dialogCliente = false
    },
    searchCep (cep = '') {
      if (cep.length === 8) {
        this.loadingCep = true
        axios.get('https://viacep.com.br/ws/' + cep + '/json/')
          .then((response) => {
            if (!response.data.erro) {
              this.cliente.cli_rua = response.data.logradouro
              this.cliente.cli_bairro = response.data.bairro
              this.cliente.cli_complemento = response.data.complemento
              if (response.data.uf) {
                this.cliente.cli_uf = response.data.uf
                this.cliente.cli_cidade = response.data.localidade
                this.filterCidade(response.data.uf)
              }
            }
          })
          .catch(err => {
            console.log(err)
            this.$root.SnackControl.open(this, {
              text: 'Erro ao buscar por CEP!',
              color: 'error'
            })
          }).finally(() => {
            this.loadingCep = false
          })
      }
    },
    getEstados () {
      this.loadingEstados = true
      axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome')
        .then((response) => {
          for (let estado = 0; estado < response.data.length; estado++) {
            this.estados.push({
              text: response.data[estado].nome,
              value: response.data[estado].sigla
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar os estados!',
            color: 'error'
          })
        })
      this.loadingEstados = false
    },
    getCidade () {
      this.loadingCidades = true
      axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/municipios')
        .then((response) => {
          for (let cidade = 0; cidade < response.data.length; cidade++) {
            this.cidades.push({
              text: response.data[cidade].nome,
              value: response.data[cidade].nome,
              uf: response.data[cidade].microrregiao.mesorregiao.UF.sigla
            })
          }
          if (this.estado) {
            this.cidadesFiltro = this.cidades.filter(city => city.uf === this.estado)
          }
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar as cidades!',
            color: 'error'
          })
        })
      this.loadingCidades = false
    },
    filterCidade (estado = null) {
      if (!estado) {
        estado = this.estado
        this.cidadesFiltro = this.cidades.filter(city => city.uf === estado)
        this.options.page = 1
        this.applyFilter()
      } else {
        this.cidadesFiltradas = this.cidades.filter(city => city.uf === estado)
      }
    },
    updateData () {
      if (JSON.parse(localStorage.getItem('user')) !== null && !this.user) {
        this.user = JSON.parse(localStorage.getItem('user'))
        if (this.user.fk_gru_id_grupo) {
          this.nivelUsuarioApelido = 'M'
        }
        if (this.user.fk_dis_id_distribuidor) {
          this.nivelUsuarioApelido = 'D'
        }
        if (this.user.fk_int_id_integrador) {
          this.nivelUsuarioApelido = 'I'
        }
      }
    }
  },
  updated () {
    this.updateData()
  },
  created () {
    this.updateData()
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>> .v-text-field--outlined .v-input__append-outer, .v-text-field--outlined .v-input__prepend-outer {
  margin-top: 8px!important;
}
.mw_600 {
  max-width: 600px;
}
</style>



// WEBPACK FOOTER //
// src/pages/cadastros/Cliente.vue